export default __webpack_public_path__ + "static/media/Monday.com.0a2c4756.png";